export enum AssetLinkedResourceType {
  TitlePoster = "TitlePoster",
  TitleCover = "TitleCover",
}

export interface AssetLinkedResource {
  resourceId: number;
  type: AssetLinkedResourceType;
}

export enum TitlePosterLocation {
  Artwork = "Artwork",
  File = "File",
}

export interface TitlePosterResource extends AssetLinkedResource {
  $type: "VDM.AirLab.Sdk.Core.Database.Types.AssetResources.TitlePosterResource, VDM.AirLab.Sdk.Core";
  type: AssetLinkedResourceType.TitlePoster;
  location: TitlePosterLocation;
}

export enum TitleCoverLocation {
  Artwork = "Artwork",
  File = "File",
}

export interface TitleCoverResource extends AssetLinkedResource {
  $type: "VDM.AirLab.Sdk.Core.Database.Types.AssetResources.TitleCoverResource, VDM.AirLab.Sdk.Core";
  type: AssetLinkedResourceType.TitleCover;
  location: TitleCoverLocation;
}

export function createTitlePosterResource(resourceId: number, location: TitlePosterLocation): TitlePosterResource {
  return {
    $type: "VDM.AirLab.Sdk.Core.Database.Types.AssetResources.TitlePosterResource, VDM.AirLab.Sdk.Core",
    type: AssetLinkedResourceType.TitlePoster,
    resourceId,
    location,
  };
}

export function createTitleCoverResource(resourceId: number, location: TitleCoverLocation): TitleCoverResource {
  return {
    $type: "VDM.AirLab.Sdk.Core.Database.Types.AssetResources.TitleCoverResource, VDM.AirLab.Sdk.Core",
    type: AssetLinkedResourceType.TitleCover,
    resourceId,
    location,
  };
}
